import { render, staticRenderFns } from "./TgCjNavBar.vue?vue&type=template&id=67c012ec&"
import script from "./TgCjNavBar.vue?vue&type=script&lang=js&"
export * from "./TgCjNavBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports